import { render, staticRenderFns } from "./ListarBonos.vue?vue&type=template&id=eff124f4&scoped=true&"
import script from "./ListarBonos.vue?vue&type=script&lang=js&"
export * from "./ListarBonos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff124f4",
  null
  
)

export default component.exports